import { ElementHelpers } from '../helpers/element-helpers';

export class ExpandRichText {
	constructor(elem) {
		this.elem = elem;
		this.richtext = document.querySelector('[data-rich-text-collapsed]');
		this.button = this.elem.querySelector('button');

		this.height = this.richtext.querySelector('.rich-text').offsetHeight;

		if (this.height >= 205) {
			this.addEventHandlers();
		} else {
			this.removeButton();
		}
	}

	static getSelector() {
		return '[data-expand-rich-text]';
	}

	addEventHandlers() {
		this.button.addEventListener('click', () => {
			this.handleClick();
		});
	}

	handleClick() {
		//remove button first prevents that browser keeps the button centered during the animation
		this.removeButton();

		//calculate height so CSS can perform eas-out animation
		this.elem.classList.add('active');
		this.height = this.richtext.querySelector('.rich-text').offsetHeight;
		this.richtext.style.height = this.height + 'px';

		// Ajust height after animation to auto
		setTimeout(() => {
			this.adjustHeight();
		}, 1000);
	}

	adjustHeight(){
		this.richtext.style.height = 'auto';
	}

	removeButton() {
		ElementHelpers.removeElement(this.elem);
	}
}
